import Icon, { IconProps } from "./Icon";

import ChevronIcon from '../../../assets/icons/chevron-up.svg?react';

const Chevron: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
      <Icon {...props}>
        <ChevronIcon />
      </Icon>
    );
  };

export default Chevron